import { config } from '@uhg-abyss/web/tools/config';
import { event } from '@uhg-abyss/web/tools/event';
import { getQueryParam } from '@sde/widgets-core/src/tools/url';
import { http } from '../../tools/http';
import { getTechnicalUserData } from './helpers';
import { parseProviders } from './parsers';
import { userAdminError, userApiError } from './errors';
import { getFeature } from '@sde/widgets-core/src/redux/tools/features';

const CONTENT_TYPE = 'application/json';
const SESSION_STORAGE_KEY = 'session-expiry-time';

export const getUserDetailsRequest = async () => {
  const { data } = await http({
    id: 'get-user-details',
    resource: 'utility',
    method: 'GET',
    withCredentials: true,
    url: getFeature('OHID_SESSION_REWORK')
      ? `${config('IDENTITY_API_URL')}/userinfo/v2`
      : `${config('IDENTITY_API_URL')}/userinfo`,
  });

  event.setData({
    adminProviderUuid: data?.admin?.uuid ? data.admin.uuid : '',
    uuid: data.uuid,
    optumId: data.username,
    username: data.username,
    userEmail: data.email,
    userFirstName: data.firstName,
    userLastName: data.lastName,
    ipAddress: data.sourceIp,
  });

  const phone = data.phone || '';

  return {
    ...data,
    adminUsername: data?.admin?.username,
    uuid: data.uuid || data.sub, // data is coming back with sub
    optumId: data.username,
    username: data.username,
    firstName: data.firstName,
    lastName: data.lastName,
    email: data.email || '',
    phone: phone.length > 10 ? phone.substring(1) : phone,
    ipAddress: data.sourceIp,
  };
};

export const validateUserRequest = async () => {
  const queryParams = getQueryParam();
  const { data, isUserApiError } = await http({
    id: 'validate-user',
    resource: 'utility',
    method: 'GET',
    withCredentials: true,
    // TODO
    url: getFeature('OHID_SESSION_REWORK')
      ? `${config('DS_API_URL')}/userpermissions`
      : `${config('DS_API_URL')}/userpermissions`,
    ...(queryParams.id && {
      query: {
        id: queryParams.id,
      },
    }),
    handleSuccess: (res) => {
      const resData = res.data || {};
      res.data = { ...res.data, ...parseProviders(resData) };

      return res;
    },
    handleError: userApiError,
  });

  const technicalUserData = getTechnicalUserData(data);

  if (technicalUserData.isInternalUser) {
    http.setHeader('isInternalUser', true);
    http.setHeader('isSuperUser', true);
  }

  if (technicalUserData.isSuperUser) {
    http.setHeader('isSuperUser', true);
  }

  if (technicalUserData.isReferralLinkRIUser) {
    http.setHeader('isIntakeUser', true);
  }

  return {
    ...data,
    ...technicalUserData,
    isUserApiError,
  };
};

export const getAdminInfo = async (adminId) => {
  const data = await http({
    id: 'ds-get-assigned-admin',
    method: 'POST',
    withCredentials: true,
    body: {
      id: adminId,
      allStatus: true,
    },
    url: `${config('DS_ADMIN_INFO_API')}`,
    headers: {
      'Content-Type': CONTENT_TYPE,
    },
    handleSuccess: (res) => {
      return res;
    },
    handleError: userAdminError,
  });

  return data;
};

export const refreshSessionRequest = async () => {
  console.log('refreshSessionRequest called');
  const { data } = await http({
    id: 'session-extend',
    resource: 'core',
    method: 'GET',
    withCredentials: true,
    url: `${config('IDENTITY_API_URL')}/authorize/callback/v2/session`,
  });

  if (data?.sessionExp) {
    storage.session.set(SESSION_STORAGE_KEY, data.sessionExp);
  }

  return data;
};
